/**
 * @fileoverview 街道配置工具
 * @description 动态获取streetKey和街道配置
 * @author wangzhongsheng
 * @version 2.0.0
 */

/**
 * 预定义的街道映射表
 */
const STREET_MAP = {
  'blz': { key: 'blz', name: '八里庄街道' },
  'yyc': { key: 'yyc', name: '亚运村街道' },
  'hjl': { key: 'hjl', name: '呼家楼街道' }
}

/**
 * 从URL动态检测街道标识
 * @param {string} url - 要检测的URL，默认为当前页面URL
 * @returns {string|null} 检测到的街道key
 */
export function detectStreetKey(url = window.location.href) {
  // 1. 检查URL参数 ?street=blz
  const urlParams = new URLSearchParams(window.location.search)
  const streetParam = urlParams.get('street')
  if (streetParam && STREET_MAP[streetParam]) {
    return streetParam
  }

  // 2. 检查路径中的街道标识 /blz/login
  const pathSegments = window.location.pathname.split('/').filter(segment => segment)
  for (const segment of pathSegments) {
    if (STREET_MAP[segment]) {
      return segment
    }
  }

  // 3. 检查域名 blz.example.com
  const hostname = window.location.hostname.toLowerCase()
  for (const streetKey in STREET_MAP) {
    if (hostname.includes(streetKey)) {
      return streetKey
    }
  }
  
  // 5. 使用正则匹配URL中任意位置的街道标识
  const streetKeys = Object.keys(STREET_MAP).join('|')
  const regex = new RegExp(`(${streetKeys})`, 'gi')
  const match = url.match(regex)
  if (match && match[0] && STREET_MAP[match[0].toLowerCase()]) {
    const foundKey = match[0].toLowerCase()
    return foundKey
  }

  // 4. 从localStorage获取已保存的街道
  const savedStreet = localStorage.getItem('bjchy_current_street')
  if (savedStreet && STREET_MAP[savedStreet]) {
    return savedStreet
  }



  return null
}

/**
 * 获取街道配置信息
 * @param {string} streetKey - 街道标识
 * @returns {Object|null} 街道配置对象
 */
export function getStreetConfig(streetKey) {
  return STREET_MAP[streetKey] || null
}

/**
 * 设置当前街道（保存到localStorage）
 * @param {string} streetKey - 街道标识
 */
export function setCurrentStreet(streetKey) {
  if (STREET_MAP[streetKey]) {
    localStorage.setItem('bjchy_current_street', streetKey)
    // 设置全局变量用于request使用
    if (typeof window !== 'undefined') {
      window.__BJCHY_CURRENT_STREET__ = streetKey
    }
  }
}

/**
 * 获取当前正在使用的街道标识
 * @returns {string|null} 当前街道key
 */
export function getCurrentStreetKey() {
  // 1. 优先从全局变量获取
  if (typeof window !== 'undefined' && window.__BJCHY_CURRENT_STREET__) {
    return window.__BJCHY_CURRENT_STREET__
  }

  // 2. 从localStorage获取
  const savedStreet = localStorage.getItem('bjchy_current_street')
  if (savedStreet && STREET_MAP[savedStreet]) {
    return savedStreet
  }

  // 3. 自动检测当前URL
  return detectStreetKey()
}

/**
 * 获取所有有效的街道标识列表
 * @returns {string[]} 有效的街道key数组
 */
export function getValidStreetKeys() {
  return Object.keys(STREET_MAP)
} 